var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m1.5 1.5 19 19m-19 0 19-19","fill":"none","stroke":"#000","strokeLinecap":"square","strokeWidth":"1.5"}));
}

Close.defaultProps = {"viewBox":"0 0 22 22"};

module.exports = Close;

Close.default = Close;
